import React from 'react';
import '../../../libs/bulma.min.css';
import './formIpSetInterfaces.css';

// Métricas comuns oferecidas no select. Quando o backend retorna uma métrica
// já configurada na interface (caso real do cliente: eth0 metric 100, eth1
// metric 1), o select pré-seleciona esse valor.
const COMMON_METRICS = [1, 100, 200, 300];

function FormIPInterfaces(props) {
  const { iface, data, handleChangeValues } = props;

  // Backend retorna:
  //   data.addrCidr  = "10.61.45.9/30"  (preferencial)
  //   data.ipaddr    = "10.61.45.9"     (retrocompat — sem prefixo)
  //   data.mask      = "255.255.255.252" (calculada server-side)
  //   data.gateway   = "10.61.45.10"
  //   data.metric    = 100
  const ip = data?.addrCidr ? data.addrCidr.split('/')[0] : (data?.ipaddr || '');
  const mask = data?.mask || '';
  const gw = data?.gateway || '';
  const metric = data?.metric != null ? String(data.metric) : '';

  // Lista de métricas para o select — inclui a do servidor se não estiver no padrão.
  const metricOptions = [...COMMON_METRICS];
  if (metric !== '' && !COMMON_METRICS.includes(Number(metric))) {
    metricOptions.unshift(Number(metric));
  }

  // IMPORTANTE: NÃO propagamos os valores pré-preenchidos ao parent na
  // montagem (era a auto-propagate via useEffect). Motivo do post-mortem
  // 2026-05-11: o parent considerava QUALQUER iface com valores no kernel
  // como "ready", então clicar "Aplicar" mandava todas as ifaces no payload,
  // e o backend (que só processa data[0]) descartava silenciosamente a iface
  // que o operador realmente quis mudar. Agora a iface só vira "ready"
  // quando o operador efetivamente digita/seleciona algo. O parent
  // (ChangeIp.computeIfaceState/applyChange) cai-back para os valores
  // atuais do kernel quando o operador não digita um campo — assim o caso
  // "ajustar só a métrica" continua funcionando.

  return (
    <div className="interface-form-card">
      <div className="interface-form-header">
        <svg className="interface-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
        <span className="interface-name">{ iface.includes('_') ? iface.split('_').join('.') : iface }</span>
      </div>
      <div className="interface-form-fields">
        <div className="interface-field">
          <label className="interface-label">IP</label>
          <input
            className="interface-input"
            name={`${iface}-ip`}
            type="text"
            placeholder="1.1.1.2"
            defaultValue={ip}
            onChange={(e) => handleChangeValues(e.target)}
          />
          <p name={`${iface}-ip-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Máscara</label>
          <input
            className="interface-input"
            name={`${iface}-mask`}
            type="text"
            placeholder="255.255.255.0"
            defaultValue={mask}
            onChange={(e) => handleChangeValues(e.target)}
          />
          <p name={`${iface}-mask-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Gateway</label>
          <input
            className="interface-input"
            name={`${iface}-gw`}
            type="text"
            placeholder="1.1.1.1"
            defaultValue={gw}
            onChange={(e) => handleChangeValues(e.target)}
          />
          <p name={`${iface}-gw-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
        <div className="interface-field">
          <label className="interface-label">Métrica <small>(opcional)</small></label>
          <select
            className="interface-select"
            name={`${iface}-metric`}
            defaultValue={metric}
            onChange={(e) => handleChangeValues(e.target)}
          >
            <option value="">— sem métrica —</option>
            {metricOptions.map((m) => <option key={m} value={m}>{ m }</option>)}
          </select>
          <p name={`${iface}-metric-invalid-data`} className='interface-error is-hidden'>Caracteres inválidos!</p>
        </div>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
